// Filtros
export const defaultParamsFilter = () => {
    return {
        // Producto
        product: '',
        // Empresa
        company_id: null,
        // Número de tanque
        number_tank: '',
        // Ubicaciones
        locations_id: [],
        // Unidades de medida
        volume_unit_id: [],
    }
};

export default {
    // Empresas seleccionadas
    valueInitialCompaniesId: null,
    // Ubicaciones
    valueInitialUnitMeasure: null,
    // Datos del filtro
    filter: defaultParamsFilter()
}